import { toast } from "react-hot-toast";
import { useQuery } from "@tanstack/react-query";
import { fetchTripsByUserId } from "../libs/services/trip.service";

type Params = {
  userId: string | null;
};

export const useFetchTrips = ({ userId }: Params) => {
  const query = useQuery({
    queryKey: ["fetching all trips by user id", userId],
    queryFn: async () => {
      try {
        if (!userId) return [];
        return await fetchTripsByUserId(userId);
      } catch (error) {
        toast.error(error.message);
        return [];
      }
    },
    enabled: Boolean(userId),
  });
  return query;
};
